import axios from "axios";

const stormwaterBaseUrl = process.env.VUE_APP_API_URL_STORMWATER;
const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 120000
});

export default {
  healthCheck() {
    return httpClient.get(stormwaterBaseUrl);
  },
  getStreetName(payload) {
    return httpClient.post(`${stormwaterBaseUrl}street-name`, payload);
  },
  validateAddress(payload) {
    return httpClient.post(`${stormwaterBaseUrl}validate-address`, payload);
  },
  fetchEstimate(payload) {
    return httpClient.post(`${stormwaterBaseUrl}estimate`, payload);
  }
};
